<template>
    <span>
       <a href="javascript:void(0);" class="btn btn-primary btn-sm transparent" v-for="(intent, index) in filterIntents" :key="'intent_prefill_'+index" @click="$emit('addIntentPrefill',intent.value)" style="margin-right: 5px;">
            {{intent.name}}
        </a>
    </span>
</template>

<script>
    export default {
        data: function(){
            return {
                search: '',
                intents: [
                    {
                        name: 'Firstname',
                        value: 'first_name',
                        description: ''
                    },
                    {
                        name: 'Lastname',
                        value: 'last_name',
                        description: ''
                    }
                ]
            }
        },
        computed: {
            filterIntents: function(){
				var vm = this
				return vm.intents.filter(intent => {
					return intent.name.toLowerCase().includes(vm.search.toLowerCase())
				})
			}
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/view/intent/IntentPrefill.vue